import React from 'react';
import { Helmet } from 'react-helmet-async';

// @mui
import { styled } from '@mui/material/styles';
import { Typography, Box, Button } from '@mui/material';

import pageTitle from "../utils/pageTitles.json";
import { BlankCard } from '../components/cards/blankCard';
import KycTitleIcon from '../assets/svgs/kycTitleIcon';
import Iconify from 'src/components/iconify';
import CampaignIcon from '@mui/icons-material/Campaign';
import { PlansListTable } from 'src/sections/plans/plansListTable';
import { useBoolean } from 'src/hooks/use-boolean';
import PlanForm from 'src/sections/plans/CreatePlanModal';
import { axiosPostCall } from 'src/services/apisCall';
import Logger from 'src/lib/Logger';
import { renderErrorMessage, renderSuccessMessage } from 'src/lib/toastMessage';

// home main section container.
const MainSection = styled('div')(({ theme }) => ({
    padding: "64px 20px 0px 88px",
    backgroundColor: "rgb(240, 240, 240)"/* theme.palette.background.default */,
    height: 'calc(100vh - 0px)',
    overflow: 'hidden'
}));

// Show home hading and filtes
const HeadingSection = styled('div')(() => ({
    width: '100%',
    padding: "20px 0px 20px 0px",
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row'
}));

const DetailsListSection = styled('div')(() => ({
    width: '100%',
    height: 'calc(100vh - 155px)',//'554px',
    overflow: 'hidden',
    overflowY: "scroll",
}));

const logger = new Logger("PlansList")

const PlansList = () => {

    const planFormModal = useBoolean();

    const handleClick = () => {
        planFormModal.onTrue();
    }
    const forceReload = useBoolean();
    const handleAddPlan = async (data, setState) => {
        try {
            setState(true)
            if(data?.plan_type === "product_id") {
                data.product_id = "Console"
            }
            const { product_id, plan_id, variations } = data

            const payload = {
                productId: product_id,
                planId: plan_id,
                variations: variations,
                newPlan: data
            }
            if(product_id === "Broadcast") {
                payload.slabs = data.slabs,
                delete data.slabs
                payload.newPlan = data;
            }
            if (variations) {
                delete data.variations
            }
            const { message } = await axiosPostCall("addNewPlan", payload)
            renderSuccessMessage(message)
            planFormModal.onFalse();
            // setLoad(true)
            planFormModal.onFalse();

            forceReload.onToggle();

        } catch (error) {
            logger.error("planList.jsx,handleAddPlan,addPlan api", error);
            renderErrorMessage(error.message)

        }
        finally {
            setState(false)

        }
    }

    const planList = (
        <Box sx={{ width: '100%' }}>
            <DetailsListSection className='reportListScroll'>
                <PlansListTable forceReload={forceReload} />
                <PlanForm open={planFormModal.value} onClose={() => { planFormModal.onFalse(); }} handleAddPlan={handleAddPlan} />
            </DetailsListSection>
        </Box>
    )

    return (
        <>
            <Helmet>
                <title> {`${pageTitle?.plan}`} </title>
            </Helmet>

            <MainSection>

                {/* Heading and filters */}
                <HeadingSection>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '10px',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <Box sx={{
                            widht: '16px',
                            height: '16px',
                            mt: -1.8
                        }}>
                            <KycTitleIcon />
                        </Box>
                        <Typography variant='h5' sx={{ color: 'grey.10', fontWeight: 600 }}>
                            Plan List
                        </Typography>
                    </Box>
                    <Button
                        startIcon={<Iconify icon="material-symbols:add" />}

                        sx={{
                            backgroundColor: 'rgb(33, 43, 54)',
                            color: 'grey.100',
                            p: '0px 20px 0px 20px',
                            '&:hover': {
                                backgroundColor: 'rgb(69, 79, 91)'
                            }
                        }}
                        onClick={() => handleClick()}
                    >
                        Add Plan
                    </Button>
                </HeadingSection>

                <BlankCard
                    key="1"
                    sx={{
                        height: '100%',
                        width: '100%',
                        padding: '0px',
                        overflow: 'hidden',
                        // borderTopLeftRadius: '0px',
                        // borderTopRightRadius: '0px'
                    }}
                >
                    {planList}
                </BlankCard>

            </MainSection>

        </>
    )
}

export default PlansList;
